import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { ChangePaymentInfoButton } from './ChangePaymentInfoButton'

export const BillingTab: React.FC = () => {
  return (
    <Container className='p-0'>
      <Row>
        <Col>
          <ChangePaymentInfoButton />
        </Col>
      </Row>
    </Container>
  )
}
